const defaultDuration = window.__cypressToastDuration || 4000;
const defaultErrorDuration = window.__cypressToastDuration || 6000;
const defaultErrorExtendedDuration = window.__cypressToastDuration || 8000;
const defaultSuccessDuration = window.__cypressToastDuration || 2000;

export {defaultDuration, defaultErrorDuration, defaultErrorExtendedDuration, defaultSuccessDuration};
